export function compareDates(date1: string, date2: string): boolean {
  const firstDate: Date = new Date(date1);
  const secondDate: Date = new Date(date2);
  return firstDate >= secondDate;
}
